import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { scroller } from 'react-scroll';

import Tabs from 'components/tabs';
import UpdatesTab from 'components/updatesTab';
import SocialMediaFeeds from 'components/socialMediaFeeds';
import MarketView from 'components/marketView';
import { MarketIndex } from 'components/marketCharts';
import AnalyticalReport from 'components/analyticalReport';
import { slugify } from 'helpers';
import { HEADER_HEIGHT, ANIMATION_SETTINGS, FEATURE_FLAGS } from 'config';

import {
  homeTabs,
  marketIndexContainer,
  dataAndResearchContainer,
} from './scss/HomeTabs.module.scss';

const tabs = [
  {
    title: 'Market View',
    render: <MarketView />,
  },
  !FEATURE_FLAGS.HIDE_DUMMY_ITEMS && {
    title: 'Index',
    render: (
      <div className={marketIndexContainer}>
        <MarketIndex theme="light" />
      </div>
    ),
  },
  {
    title: 'Data & Research',
    render: (
      <div className={dataAndResearchContainer}>
        <AnalyticalReport />
      </div>
    ),
  },
  {
    title: 'Updates',
    render: <UpdatesTab />,
  },
  {
    title: 'Social Media',
    render: <SocialMediaFeeds />,
  },
].filter(Boolean);

const HomeTabs = ({ defaultTab }) => {
  const [activeTab, setActiveTab] = useState('1');
  const handleTabClick = tab => {
    activeTab !== tab && setActiveTab(tab);
  };

  useEffect(() => {
    if (defaultTab) {
      const defaultTabIndex = tabs.findIndex(
        tab => slugify(tab.title) === defaultTab
      );
      setActiveTab(defaultTabIndex + 1 + '');
      scroller.scrollTo('homeTabs', {
        smooth: true,
        duration: ANIMATION_SETTINGS.ANIMATION_DURATION.NORMAL,
        offset: -20 - HEADER_HEIGHT,
      });
    }
  }, [defaultTab]);

  return (
    <section className={homeTabs} name="homeTabs">
      <Tabs tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick} />
    </section>
  );
};

HomeTabs.propTypes = {
  defaultTab: PropTypes.string,
};

HomeTabs.defaultProps = {
  defaultTab: null,
};

export default HomeTabs;
